import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">MEESMARKETING</Link>
          <ul className="nav-links">
            <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
            <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
            <li><Link to="/services" className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
            <li><Link to="/compliance" className={location.pathname === '/compliance' ? 'active' : ''}>Compliance</Link></li>
            <li><Link to="/privacy" className={location.pathname === '/privacy' ? 'active' : ''}>Privacy</Link></li>
            <li><Link to="/terms" className={location.pathname === '/terms' ? 'active' : ''}>Terms</Link></li>
            <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
            <li><Link to="/verification" className={location.pathname === '/verification' ? 'active' : ''}>Verification</Link></li>
          </ul>
          <div className="mobile-menu" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className={`nav-mobile ${mobileMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><Link to="/" onClick={closeMobileMenu} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
              <li><Link to="/about" onClick={closeMobileMenu} className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
              <li><Link to="/services" onClick={closeMobileMenu} className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
              <li><Link to="/compliance" onClick={closeMobileMenu} className={location.pathname === '/compliance' ? 'active' : ''}>Compliance</Link></li>
              <li><Link to="/privacy" onClick={closeMobileMenu} className={location.pathname === '/privacy' ? 'active' : ''}>Privacy</Link></li>
              <li><Link to="/terms" onClick={closeMobileMenu} className={location.pathname === '/terms' ? 'active' : ''}>Terms</Link></li>
              <li><Link to="/contact" onClick={closeMobileMenu} className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
              <li><Link to="/verification" onClick={closeMobileMenu} className={location.pathname === '/verification' ? 'active' : ''}>Verification</Link></li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;